// Polyfill Promise.withResolvers for older browsers (react-pdf requirement)
if (!Promise.withResolvers) {
  (Promise as any).withResolvers = () => {
    let resolve: any, reject: any;
    const promise = new Promise((res, rej) => { resolve = res; reject = rej; });
    return { promise, resolve, reject };
  };
}

import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
}

import { initAnalytics } from "./lib/analytics";
initAnalytics();

import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";
import "./i18n/config";

createRoot(document.getElementById("root")!).render(<App />);
  